!(function(win, doc, $) {
  (function(){
    var layer = $('<div />').attr('id', '').attr('style', 'position:fixed;left:0;top:0;width:100%;height:100%;opacity:0.9;background:#000;display:none;z-index:10000');
    $('body').append(layer);
    $(document).on('click', '[rel="modal"]', function(event) {
      $($(this).attr('href')).show();
      layer.show();
      event.preventDefault();
    });
    $.fn.modal = function(options) {
      return this.each(function() {
        var $this = $(this);
        $(options.close).on('click', function() {
          $this.hide();
          layer.hide();
        })
      });
    }

    $.fn.toggleModal = function(hide) {
      if(hide) {
        this.hide();
        layer.hide();
      }else {
        this.show();
        layer.show();
      }
    }
  })();

  function Login(options) {
    this.options = $.extend({}, this.defaults, options);
    this.isLogin = false;
    this.el = {};
    this.init();
  }

  Login.prototype = {
    constructor: Login,

    defaults: {
      loginCallback: function(){
        $.ajax({
          url: 'http://activity.polyv.net/ticket/17-10/get',
          type: 'get',
          dataType: 'jsonp'
        }).done(function(json){
          if(json.status === "success"){
            var length = json.tickets.length;
            for(var i = 0; i < length; i++){
                if(json.tickets[i].ticketName == '注册免费礼'){
                    $('#reward-reg').attr('disabled','disabled').css({'background-color':'grey','box-shadow':'none','cursor':'default'}).text('已领取');
                }
            }
            $('.js-mask').hide();
          }
        });
      },
      quitLoginCallback: function(){},
      firstLogin: function(){}
    },

    selector: {
      $loginmodal: '#loginmodal',
      loginClose: '.modal-close',
      $loginform: '#loginform',
      quitLogin: '.js-quitLogin',
      $loginCtrl: '#loginCtrl',
      $login: '#login',
      $notLogin: '#notLogin',
      $password: '#password'
    },

    ajaxUrl: {
      checkLogin: 'http://activity.polyv.net/getUser',
      login: 'http://activity.polyv.net/login',
      quitLogin: 'http://activity.polyv.net/loginout'
    },

    method: {
      loginSubmit: function(callback) {
        return (function(event){
          var self = this;
          var data = $(event.target).serialize();
          $.ajax({
            url: this.ajaxUrl.login,
            dataType: 'jsonp',
            data: data
          }).done(function(res) {
            if(res.status === "failure" || res.status === 'fail') {
              alert(res.message || res.errorMsg);
              return;
            }
            self.setIsLogin(true);
            self.renderLogin('seccess', res.email);
            self.el.$loginmodal.toggleModal(true);
            self.el.$password.val('');
            if(callback) callback.call(self);
          });

          return false;
        }).bind(this);
      }
    },

    init: function() {
      this.getElements();
      this.loginInit();
    },

    setIsLogin: function(bool) {
      if(this.isLogin === bool) return;
      this.isLogin = bool;
      if(bool) {
        this.options.loginCallback();
      } else {
        this.options.quitLoginCallback();
      }
    },

    getElements: function() {
      for (let key in this.selector) {
        if (key[0] === '$' && this.selector.hasOwnProperty(key)) {
          this.el[key] = $(this.selector[key]);
        }
      }
    },

    loginInit: function(callback) {
      this.el.$loginmodal.modal({
        close: this.selector.loginClose
      });
      this.el.$loginform.submit(this.method.loginSubmit.call(this, function(){}));
      $(document).on('click', this.selector.quitLogin, this.quitLogin.bind(this));
      var self = this;
      this.el.$loginCtrl.empty();
      this.getLoginData()
        .done(function(res) {
          self.setIsLogin(res.status === 'fail' ? false : true);
          self.renderLogin(res.status, res.email || '');
          self.options.firstLogin(self.isLogin);
          if(callback) callback.call(self);
        }).fail(function() {
          self.setIsLogin(false);
          self.renderLogin(false, '');
        });
    },

    loginAjax: function(dtd) {
      $.ajax({
        url: this.ajaxUrl.checkLogin,
        dataType: 'jsonp'
      })
      .done(function(res) {
        dtd.resolve(res);
      });
      return dtd;
    },

    getLoginData: function() {
      var deferred = $.Deferred();
      return $.when(this.loginAjax(deferred));
    },

    renderLogin: function(type, email) {
      if(type === 'fail') {
        this.el.$loginCtrl.empty().append(this.el.$notLogin.show());
      }else {
        this.el.$login.children('span').html(email);
        this.el.$loginCtrl.empty().append(this.el.$login.show());
      }
    },

    quitLogin: function() {
      var self = this;
      if(this.isLogin) {
        $.ajax({
          url: this.ajaxUrl.quitLogin,
          dataType: 'jsonp'
        }).done(function() {
          self.renderLogin('fail');
          self.setIsLogin(false);
          $('#reward-reg').attr('disabled',false).css({'background-color':'#2456ed','box-shadow':'0 1px 0.5rem 0 rgba(36,86,237,.85)','cursor':'pointer'}).text('立即领取');
        });
      }
    },

    show: function() {
      this.el.$loginmodal.toggleModal();
    },

    hide: function() {
      this.el.$loginmodal.toggleModal(true);
    }
  };

  win.Login = Login;
  new Login();
})(window, document, jQuery);